import { network } from './network';
import {
  ChangeNote,
  FirstWeekReport,
  FirstWeekSegment,
  HealthRow,
  HistoryFillStatus,
  Milestone,
  MilestoneRequest
} from '../types/firstWeekTypes';

const BASE = '/admin/first-week';

const getReport = (segment: FirstWeekSegment, from: string, to: string) =>
  network.get<FirstWeekReport>(BASE, { segment, from, to });
const getHealth = (days: number) => network.get<HealthRow[]>(`${BASE}/health`, { days });
const createMilestone = (request: MilestoneRequest) => network.post<Milestone>(`${BASE}/milestones`, request);
const deleteMilestone = (id: number) => network.delete<void>(`${BASE}/milestones/${id}`);
const createNote = (date: string, text: string) => network.post<ChangeNote>(`${BASE}/notes`, { date, text });
const deleteNote = (id: number) => network.delete<void>(`${BASE}/notes/${id}`);
const getHistoryFill = () => network.get<HistoryFillStatus>(`${BASE}/history-fill`);
// apisauce sends the second argument of post as the body; the backend reads these as query parameters.
const startHistoryFill = (from: string) => network.post<HistoryFillStatus>(`${BASE}/history-fill?from=${from}&stripe=true`);

export const firstWeekApi = {
  getReport,
  getHealth,
  createMilestone,
  deleteMilestone,
  createNote,
  deleteNote,
  getHistoryFill,
  startHistoryFill
};
